import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const SeePreviewContainer = styled.div`
  margin-top: 40px;

  @media (max-width: 576px) {
    margin-top: 0;
    margin-bottom: 20px;
  }
`;
